<div class="mapHeader">
  <h2 class="map-header-title">{{ 'Global-mapComponent-TITLE' | translate }}</h2>
  <p>{{ 'Global-mapComponent-DESC' | translate }}</p>
  <p><b>Note: </b>{{ 'Global-mapComponent-NOTE1' | translate }}</p>
  <p>{{ 'Global-mapComponent-NOTE2' | translate }}</p>

  <div *ngIf="error">
    <b>{{ 'Global-mapComponent-LOCATION_LOAD_ERROR' | translate }}</b>
  </div>

  <app-loader [loading]="loading"></app-loader>
</div>

<div class="mapContainer" *ngIf="!error">
  <google-map
  *ngIf="scriptLoaded"
    [height]="height + 'px'"
    [width]="'100%'"
    [zoom]="zoom"
    [center]="center"
    (mapClick)="mapClick()"
  >
    <map-marker
      *ngFor="let location of locations; let i = index"
      #markerElem="mapMarker"
      [position]="{ lat: location.latitude, lng: location.longitude }"
      (mapClick)="openInfo(markerElem, location)"
    >
    </map-marker>
    <map-info-window #infoWindow>
  <div *ngIf="selectedLocation">
    <a [href]="'//' + selectedLocation.URL" target="_blank">
      {{ selectedLocation.name }}
    </a>
  </div>
</map-info-window>
  </google-map>
</div>
